export {
  default,
  default as SavedCoursesOnboardingTour,
} from './SavedCoursesOnboardingTour';
